var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(!_vm.isLoading)?_c('h5',{staticClass:"mb-0"},[_vm._v("\n    Total:\n    "),_c('span',{staticClass:"total-amount"},[_vm._v("\n      "+_vm._s(_vm.value)+" "+_vm._s(_vm.currencyCode)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }